import { render, staticRenderFns } from "./StdSizeExtends.vue?vue&type=template&id=6c4d4fcc&scoped=true"
import script from "./StdSizeExtends.vue?vue&type=script&lang=js"
export * from "./StdSizeExtends.vue?vue&type=script&lang=js"
import style0 from "./StdSizeExtends.vue?vue&type=style&index=0&id=6c4d4fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d4fcc",
  null
  
)

export default component.exports